import Directory from '../../components/directory/directory.component';

const Home=()=>{
    return(
      <div>
        <Directory/>
      </div>
    );
}


export default Home;